import { render, staticRenderFns } from "./folder-detail.vue?vue&type=template&id=4723fb42&scoped=true&"
import script from "./folder-detail.vue?vue&type=script&lang=ts&"
export * from "./folder-detail.vue?vue&type=script&lang=ts&"
import style0 from "./folder-detail.vue?vue&type=style&index=0&id=4723fb42&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4723fb42",
  null
  
)

export default component.exports